import React from 'react'
import { connect } from 'react-redux'
import Highlighter from 'react-highlight-words'
import escape from 'escape-string-regexp'

import { highlight } from 'styles/colors'
import { tokensSelector } from 'selectors'

const Highlighted = ({ className, children, tokens }) =>
  children ? (
    <div className={className}>
      <Highlighter
        highlightClassName="YourHighlightClass"
        searchWords={tokens.map(token => `(^| )${escape(token)}( |,|$)`)}
        highlightStyle={{
          backgroundColor: highlight,
        }}
        textToHighlight={children || ''}
      />
    </div>
  ) : null

const mapStateToProps = state => ({
  tokens: tokensSelector(state) || [],
})

export default connect(mapStateToProps)(Highlighted)



// WEBPACK FOOTER //
// ./src/components/Highlighted.js